import React, { FC, memo } from "react";

import LocationBlue from "Assets/images/location_blue.svg";
import Point from "Assets/images/point.svg";
import { areEqualShallow } from "Utils/areEqual";
import { motion } from "framer-motion";

interface Props {
  points: Array<object>;
  pointsLength: number;
  idx: number;
  classes: any;
}
const PointList: FC<Props> = memo(
  ({ points, pointsLength, idx, classes }: Props) => {
    const sortedPoints =
      points &&
      points
        .slice()
        // eslint-disable-next-line dot-notation
        .sort((a, b) => Number(a["sort_order"]) - Number(b["sort_order"]));
    const list = sortedPoints.map((point: any, index: number) => {
      const { lat, lng, title = "" } = point;

      return (
        <motion.button
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: index / 15,
            duration: 0.5,
            ease: [0.28, 0.57, 0.2, 1],
          }}
          type="button"
          key={`${idx}-${title}-${index.toString}-${lat}-${lng}`}
          className={`${classes.button} ${classes.textAlignLeft}`}
        >
          <div style={{ display: "flex" }}>
            <div className={`${classes.verticalAlign}`}>
              {index < pointsLength - 1 ? <Point /> : <LocationBlue />}
            </div>
            <div className={`${classes.stopName} ${classes.verticalAlign}`}>
              {title}
            </div>
          </div>
          {index < pointsLength - 1 && (
            <motion.div>
              <div className={classes.stopContainer}>
                <div className={classes.stop} />
              </div>
              <div className={classes.stopContainer}>
                <div className={classes.stop} />
              </div>
              <div className={`${classes.stopContainer}`}>
                <div className={classes.stop} />
              </div>
            </motion.div>
          )}
        </motion.button>
      );
    });
    return (
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: "auto" }}
        transition={{
          duration: 0.5,
          ease: [0.28, 0.57, 0.2, 1],
        }}
      >
        {list}
      </motion.div>
    );
  },
  areEqualShallow
);

export default PointList;
